<template>
  <v-flex xs12>
    <v-title>Director Details</v-title>
    <v-card>
      <v-layout row wrap class="ma-1">
        <v-flex xs3 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="yrsEstablished"
            rules="required|numeric"
          >
            <v-text-field
              type="number"
              v-model="editableDealerManager.yrsEstablished"
              label="Years Established"
              :error-messages="errors"
              data-vv-name="yrsEstablished"
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="directorsName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.directorsName"
              label="Director's Name"
              :error-messages="errors"
              data-vv-name="directorsName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="driversLicense"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.driversLicense"
              label="Drivers Licence Number"
              :error-messages="errors"
              data-vv-name="driversLicense"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="telephoneNo"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.telephoneNo"
              label="Telephone"
              :error-messages="errors"
              data-vv-name="telephoneNo"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="mobileNo"
            rules="required|mobilenumber"
          >
            <v-text-field
              v-model="editableDealerManager.mobileNo"
              label="Mobile"
              :error-messages="errors"
              data-vv-name="mobileNo"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="email"
            rules="required|email"
          >
            <v-text-field
              v-model="editableDealerManager.email"
              label="Email"
              :error-messages="errors"
              data-vv-name="email"
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="numberSubAgents"
            rules="required"
          >
            <v-text-field
              name="numberSubAgents"
              label="Number of Sub Agents"
              v-model="editableDealerManager.numberSubAgents"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs12></v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="firstName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.firstName"
              label="Contact First Name"
              :error-messages="errors"
              data-vv-name="firstName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="lastName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.lastName"
              label="Contact Last Name"
              :error-messages="errors"
              data-vv-name="lastName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'edit-company-details',
  props: {
    dealerManager: {
      type: Object,
      required: true,
    },
  },
  computed: {
    editableDealerManager: {
      get() {
        return this.dealerManager;
      },
      set(val) {
        this.$emit('update:dealerManager', val);
      },
    },
  },
};
</script>
